import React from 'react';
import EmptyData from 'components/Messages/EmptyData/EmptyData';
import { TableColumnInterface } from 'components/Table/table.types';
import OverviewTable from 'components/Table/Table';
import { ActivityInterface, useActivitiesContext } from '../../Activities/activities.context';
import { Link } from 'react-router-dom';
import {
  convertHTMLStringToPlainString,
  formatDatePickerDate,
  truncateText,
} from 'utils/formatting';
import ActivityFilters from '../../Activities/Table/Filters';
import { getActivityStatus } from '../../Activities/utils';

const ReportsTable = (): JSX.Element => {
  const { activities } = useActivitiesContext();

  const getCompletedStepCount = (activity: ActivityInterface) => {
    if (!activity.steps) return 0;

    let completedStepCount = 0;

    activity.steps.forEach((step) => {
      if (step.completedDate) completedStepCount++;
    });

    return completedStepCount;
  };

  const tableCols: TableColumnInterface<ActivityInterface>[] = [
    {
      label: 'Subject',
      value: (activity) => (
        <Link to={`/activities/${activity.id}`}>{truncateText(activity.subject || 'N/A', 30)}</Link>
      ),
      sortBy: 'subject',
    },
    {
      label: 'Description',
      value: (activity) => convertHTMLStringToPlainString(activity.description),
      sortBy: 'description',
    },
    {
      label: 'Assigned To',
      value: (activity) =>
        activity.assignedUsers.map((user) => `${user.firstName} ${user.lastName}`).join(', '),
    },
    {
      label: 'Status',
      value: (activity) => getActivityStatus(activity),
      sortBy: 'state',
    },
    {
      label: 'Due Date',
      value: (activity) => formatDatePickerDate(activity.dueDate),
      sortBy: 'dueDate',
    },
    {
      label: 'Completed',
      value: (activity) => <>{`${getCompletedStepCount(activity)} of ${activity.steps.length}`}</>,
    },
    {
      label: '',
      align: 'right',
      value: () => <Link to={''}>View Responses</Link>, // This needs to be populated
    },
  ];

  return (
    <>
      <ActivityFilters />
      <OverviewTable
        data={activities}
        columns={tableCols}
        noDataMessageOverride={<EmptyData dataType='activity' />}
      />
    </>
  );
};

export default ReportsTable;
